
import { Vue, Component, Watch } from "vue-property-decorator"
import api from "../honcierge-api"
import EditDialog from "@/components/SubCategory/EditDialog.vue"
import TableItemIsEnabled from "@/components/_share/TableItemIsEnabled.vue"
import { AxiosError } from "axios"
import { Category, SubCategory } from "types/index"
import { DataTableHeader } from "vuetify/types"

@Component({
  components: { EditDialog, TableItemIsEnabled },
})
export default class SubCategories extends Vue {
  private loading = false
  private categoriesForSearch: Category["view"][] = []
  private categoryForSearch: Category["view"] | null = null
  private subCategoryNameForSearch = ""
  private totalPages = 0
  private subCategories: SubCategory["data"][] = []
  private totalItems = 0
  private pagination = {
    sortBy: ["categoryName"],
    sortDesc: [false],
    itemsPerPage: -1,
    page: 1,
  }

  get headers(): DataTableHeader[] {
    return [
      { text: "名称", value: "name" },
      { text: "カテゴリー名", value: "categoryName" },
      { text: "カテゴリー内順序", value: "order" },
      { text: "URL", value: "urlKey" },
      { text: "パンくずステータス", value: "breadcrumbStatus" },
      { text: "トップページに表示", value: "showOnTop" },
      { text: "有効/無効", value: "isEnabled" },
      { text: "バナー", value: "banner", sortable: false },
      { text: "操作", value: "action", sortable: false },
    ]
  }

  public created(): void {
    this.getCategoriesForSearch()
  }

  @Watch("pagination.page", { deep: true, immediate: true })
  private onChangePage() {
    this.loading = true
    this.getSubCategories()
  }

  private getCategoriesForSearch() {
    api
      .getCategories({
        search: "",
        page: 1,
        per: 1000000,
        includeDisabled: false,
        sortBy: "priority",
        descending: true,
        fields: ["id", "name"],
      })
      .then((res) => {
        this.categoriesForSearch.length = 0
        this.categoriesForSearch = res.data.categories
      })
      .catch((e) => {
        console.log(e.stack)
      })
  }

  private getSubCategories(page?: number) {
    api
      .getSubCategories({
        categoryIds:
          this.categoryForSearch && this.categoryForSearch.id
            ? [this.categoryForSearch.id]
            : null,
        excludeIds: null,
        name: this.subCategoryNameForSearch,
        sortBy: this.pagination.sortBy[0],
        descending: this.pagination.sortDesc[0],
        page: page ? page : this.pagination.page,
        per: 10,
        includeDisabled: true,
        fields: [
          "id",
          "name",
          "order",
          "urlKey",
          "breadcrumbStatus",
          "showOnTop",
          "isEnabled",
          "banner",
        ],
        withCategory: true,
      })
      .then((res) => {
        this.totalPages = res.data.meta.totalPages
        this.subCategories.length = 0
        this.subCategories = res.data.subCategories
        this.totalItems = this.subCategories.length
        this.loading = false
      })
      .catch((e: AxiosError) => {
        console.log(e.stack)
      })
  }

  private searchSubCategories() {
    this.resetPagination()
    this.getSubCategories()
  }

  private resetPagination() {
    this.pagination.page = 1 // pageを変更するとonChangePage()が呼び出されることに注意
  }

  private updateSubCategory() {
    this.getSubCategories()
  }

  private open(id?: number) {
    if (id) {
      const refs = this.$refs[id] as InstanceType<typeof EditDialog>
      if (Array.isArray(refs)) {
        refs[0].open()
      } else {
        refs.open()
      }
    } else {
      const newDialog = this.$refs.newDialog as InstanceType<typeof EditDialog>
      newDialog.open()
    }
  }

  private existBanner(banner: { filename: string; url: string }): boolean {
    return banner.filename !== null && banner.url !== null
  }
}
